import { Link } from "react-router-dom";

const AboutSection = ({ language }) => {

  const lang = language === "CN" ? "zh" : "en";

  const content = {
    en: {
      tag: "WHO WE ARE",
      title1: "More than advisors. We are your",
      title2: "Trusted Partners.",
      p1: "JT Group is a full-service financial advisory firm and authorised representative of AIA Singapore. With nearly three decades of experience, we serve individuals, families, businesses, and high-net-worth clients with integrity, expertise, and genuine care.",
      p2: "Our philosophy is simple: your goals are our goals. Whether you are planning for retirement, protecting your business, or building a legacy for generations to come, we are by your side every step of the way.",
      btn: "Learn More About Us →",
    },

    zh: {
      tag: "关于我们",
      title1: "不仅仅是顾问，我们是您的",
      title2: "值得信赖的合作伙伴",
      p1: "JT Group 是一家提供全方位服务的金融咨询公司，也是 AIA 新加坡的授权代表。凭借近三十年的经验，我们以诚信、专业和关怀服务个人、家庭、企业以及高净值客户。",
      p2: "我们的理念很简单：您的目标就是我们的目标。无论您是在规划退休、保护企业，还是为下一代建立财富传承，我们都会全程陪伴。",
      btn: "了解更多 →",
    },
  };

  return (
    <section className="bg-[#f7f7f7] py-10">
      <div className="max-w-[1320px] mx-auto px-4">
        <div className="grid lg:grid-cols-12 items-center gap-12">

          <div className="lg:col-span-5">
            <img
              src="/assets/images/1744532344360-1-1536x1510.jpeg"
              alt="About JT Group"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="lg:col-span-7">

            <span className="text-[#C69C6D] text-sm font-bold tracking-wide">
              {content[lang].tag}
            </span>

            <h2 className="text-[28px] md:text-[34px] font-medium text-[#154059] leading-snug mt-2">
              {content[lang].title1}
              <br className="hidden md:block" />
              <span className="text-[#C69C6D]">
                {content[lang].title2}
              </span>
            </h2>

            <p className="text-gray-600 mt-3 leading-relaxed text-[15px] text-justify sm:text-left">
              {content[lang].p1}
            </p>

            <p className="text-gray-600 mt-4 leading-relaxed text-[15px] text-justify sm:text-left">
              {content[lang].p2}
            </p>

            <Link
              to="/about"
              className="inline-block mt-4 font-semibold text-[#C69C6D] hover:text-[#a88257] transition"
            >
              {content[lang].btn}
            </Link>

          </div>

        </div>
      </div>
    </section>
  );
};

export default AboutSection;